module.exports = __webpack_public_path__ + "img/kc10.af46b88f.png";